(function($) {

  'use strict';

  const countUp = require('./../libs/countUp.umd');

  const StatCounter = function() {

      const init = function() {
        const elements = document.querySelectorAll('[data-js-count]');
        [...elements].forEach(element => {
          element.addEventListener('sal:in', ({ detail }) => {
            const target = detail.target.getAttribute('data-js-count')
              ? detail.target.getAttribute('data-js-count')
              : '';
            const statCounter = new countUp.CountUp(detail.target, target, {
              separator: ','
            });

            if (!statCounter.error) {
              statCounter.start();
            }
          });
        });
      };

      return {
          init: init
      };

  }();

  module.exports = StatCounter;

})(jQuery);
